import { render, staticRenderFns } from "./header.vue?vue&type=template&id=69cff8cf&"
import script from "./header.vue?vue&type=script&lang=ts&"
export * from "./header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69cff8cf')) {
      api.createRecord('69cff8cf', component.options)
    } else {
      api.reload('69cff8cf', component.options)
    }
    module.hot.accept("./header.vue?vue&type=template&id=69cff8cf&", function () {
      api.rerender('69cff8cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/header.vue"
export default component.exports